import React from 'react';
import { Link } from 'react-router-dom';

const KacherypladyLandingPage: React.FC = () => {
  const handleCallClick = () => {
    window.open('tel:+918123996838', '_self');
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/918123996838', '_blank');
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <div className="flex items-center space-x-4">
                <img 
                  src="https://static.readdy.ai/image/1f14fa9f4e25dd8748ff61378ea7fc70/5f18070c14f635b56d649c93b3a8f8e0.png"
                  alt="Galaxy Dental Care Logo"
                  className="h-12 w-auto"
                />
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <a href="tel:+918123996838" className="text-slate-700 font-bold hover:text-slate-800 flex items-center text-lg">
                <span className="whitespace-nowrap">Emergency Call: 8123996838</span>
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative bg-white py-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-slate-50 to-white"></div>
        
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-20 left-10 w-40 h-40 bg-slate-200 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-60 h-60 bg-slate-300 rounded-full blur-3xl"></div>
          <div className="absolute top-1/2 left-1/3 w-32 h-32 bg-slate-100 rounded-full blur-2xl"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center min-h-[600px]">
            {/* Left Content */}
            <div className="space-y-8">
              <div className="space-y-6">
                <div className="inline-flex items-center bg-slate-100 text-slate-700 px-4 py-2 rounded-full text-sm font-medium">
                  <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center mr-2"></i>
                  Kacherypady Branch • SRM Road
                </div>
                
                <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 leading-tight">
                  Top Rated Dental 
                  <span className="text-slate-600 block">Clinic near Kaloor</span>
                </h1>
                
                <p className="text-xl text-gray-600 leading-relaxed max-w-lg">
                  Experience world-class dental care with advanced treatments, expert dentists, 
                  and a comfortable environment for your perfect smile.
                </p>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <button 
                  onClick={handleCallClick}
                  className="bg-slate-700 text-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-slate-800 transition-all duration-300 transform hover:scale-105 flex items-center justify-center whitespace-nowrap cursor-pointer shadow-xl"
                >
                  <i className="ri-phone-line w-6 h-6 flex items-center justify-center mr-3 flex-shrink-0"></i>
                  <span className="whitespace-nowrap">Call: 8123996838</span>
                </button>
                <button 
                  onClick={handleWhatsAppClick}
                  className="bg-emerald-600 text-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-emerald-700 transition-all duration-300 transform hover:scale-105 flex items-center justify-center whitespace-nowrap cursor-pointer shadow-xl"
                >
                  <i className="ri-whatsapp-line w-6 h-6 flex items-center justify-center mr-3 flex-shrink-0"></i>
                  <span className="whitespace-nowrap">WhatsApp: 8123996838</span>
                </button>
              </div>
              
              <div className="grid grid-cols-3 gap-6 pt-8">
                <div className="text-center p-4 bg-white rounded-xl shadow-lg border border-slate-100">
                  <div className="text-3xl font-bold text-slate-600 mb-1">10+</div>
                  <div className="text-sm text-gray-600">Years Experience</div>
                </div>
                <div className="text-center p-4 bg-white rounded-xl shadow-lg border border-slate-100">
                  <div className="text-3xl font-bold text-slate-600 mb-1">5000+</div>
                  <div className="text-sm text-gray-600">Happy Patients</div>
                </div>
                <div className="text-center p-4 bg-white rounded-xl shadow-lg border border-slate-100">
                  <div className="flex items-center justify-center mb-1">
                    <span className="text-3xl font-bold text-amber-500">5</span>
                    <i className="ri-star-fill w-6 h-6 flex items-center justify-center text-amber-500 ml-1"></i>
                  </div>
                  <div className="text-sm text-gray-600">Google Rating</div>
                </div>
              </div>
            </div>
            
            {/* Right Image */}
            <div className="relative">
              <div className="relative z-10">
                <img 
                  src="https://public.readdy.ai/ai/img_res/76ab6be1636c06ff18385e13a14f4b6f.jpg"
                  alt="Galaxy Dental Care Modern Clinic Interior"
                  className="rounded-3xl shadow-2xl w-full h-auto object-cover"
                />
                
                {/* Floating Info Card */}
                <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-2xl shadow-xl border border-slate-100 max-w-xs">
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center">
                      <i className="ri-time-line w-6 h-6 flex items-center justify-center text-emerald-600"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">Open Daily</div>
                      <div className="text-sm text-gray-600">10:00 AM - 8:00 PM</div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Background Decoration */}
              <div className="absolute -top-6 -right-6 w-full h-full bg-gradient-to-br from-slate-100 to-slate-200 rounded-3xl opacity-20 z-0"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Why Choose Galaxy Dental Care?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Your trusted dental partner in Ernakulam North, providing exceptional care with modern technology
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-6 rounded-lg bg-slate-50">
              <div className="w-16 h-16 bg-slate-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-star-line text-white text-2xl w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Expert Dentists</h3>
              <p className="text-gray-600">
                Highly qualified and experienced dental professionals committed to your oral health
              </p>
            </div>
            <div className="text-center p-6 rounded-lg bg-slate-50">
              <div className="w-16 h-16 bg-slate-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-hospital-line text-white text-2xl w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Modern Equipment</h3>
              <p className="text-gray-600">
                State-of-the-art dental technology for precise diagnosis and comfortable treatment
              </p>
            </div>
            <div className="text-center p-6 rounded-lg bg-slate-50">
              <div className="w-16 h-16 bg-slate-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-line text-white text-2xl w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Prime Location</h3>
              <p className="text-gray-600">
                Conveniently located on SRM Road, near MG Road, easily accessible from Ernakulam North
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Our Dental Services
            </h2>
            <p className="text-xl text-gray-600">
              Comprehensive dental care for all your oral health needs
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <img 
                src="//img1.wsimg.com/isteam/ip/ee1f3b41-f15d-4311-bbbf-92370b0fac50/GSD-Straighten-Your-Teeth-with-Invisalign_C2_.webp/:/cr=t:12.49%25,l:0%25,w:100%25,h:75.03%25/rs=w:400,h:200,cg:true"
                alt="Dental Aligners"
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Clear Aligners</h3>
              <p className="text-gray-600 mb-4">
                Straighten your teeth discreetly with our affordable clear aligner treatment
              </p>
              <button 
                onClick={handleCallClick}
                className="text-slate-600 font-semibold hover:text-slate-700 cursor-pointer whitespace-nowrap"
              >
                Book Consultation →
              </button>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <img 
                src="https://img1.wsimg.com/isteam/stock/33541/:/rs=w:400,h:200,cg:true,m/cr=w:400,h:200"
                alt="Root Canal Treatment"
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Root Canal Treatment</h3>
              <p className="text-gray-600 mb-4">
                Pain-free root canal therapy to save your natural teeth and restore oral health
              </p>
              <button 
                onClick={handleCallClick}
                className="text-slate-600 font-semibold hover:text-slate-700 cursor-pointer whitespace-nowrap"
              >
                Book Consultation →
              </button>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <img 
                src="https://img1.wsimg.com/isteam/stock/89850/:/cr=t:4.87%25,l:0%25,w:100%25,h:90.27%25/rs=w:400,h:200,cg:true"
                alt="Teeth Whitening"
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Teeth Whitening</h3>
              <p className="text-gray-600 mb-4">
                Professional teeth whitening for a brighter, more confident smile
              </p>
              <button 
                onClick={handleCallClick}
                className="text-slate-600 font-semibold hover:text-slate-700 cursor-pointer whitespace-nowrap"
              >
                Book Consultation →
              </button>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <img 
                src="//img1.wsimg.com/isteam/ip/ee1f3b41-f15d-4311-bbbf-92370b0fac50/8.jpg/:/cr=t:5.59%25,l:0%25,w:100%25,h:88.82%25/rs=w:400,h:200,cg:true"
                alt="Dental Implants"
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Dental Implants</h3>
              <p className="text-gray-600 mb-4">
                Permanent solution for missing teeth with natural-looking results
              </p>
              <button 
                onClick={handleCallClick}
                className="text-slate-600 font-semibold hover:text-slate-700 cursor-pointer whitespace-nowrap"
              >
                Book Consultation →
              </button>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <img 
                src="https://img1.wsimg.com/isteam/stock/96385/:/cr=t:12.36%25,l:0%25,w:100%25,h:75.28%25/rs=w:400,h:200,cg:true"
                alt="Kids Dentistry"
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Kids Dentistry</h3>
              <p className="text-gray-600 mb-4">
                Gentle and specialized dental care for children in a comfortable environment
              </p>
              <button 
                onClick={handleCallClick}
                className="text-slate-600 font-semibold hover:text-slate-700 cursor-pointer whitespace-nowrap"
              >
                Book Consultation →
              </button>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <img 
                src="//img1.wsimg.com/isteam/ip/ee1f3b41-f15d-4311-bbbf-92370b0fac50/shutterstock_1810254406.jpg/:/rs=w:400,h:200,cg:true,m/cr=w:400,h:200"
                alt="Dental Veneers"
                className="w-full h-48 object-cover rounded-lg mb-4"
              />
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Dental Veneers</h3>
              <p className="text-gray-600 mb-4">
                Transform your smile with custom porcelain veneers for a perfect appearance
              </p>
              <button 
                onClick={handleCallClick}
                className="text-slate-600 font-semibold hover:text-slate-700 cursor-pointer whitespace-nowrap"
              >
                Book Consultation →
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Emergency Care CTA */}
      <section className="py-16 bg-orange-500 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Dental Emergency? We're Here to Help!
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Don't suffer in pain. Our emergency dental services are available when you need them most.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={handleCallClick}
              className="bg-white text-orange-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-phone-line w-5 h-5 flex items-center justify-center mr-2 flex-shrink-0"></i>
              <span className="whitespace-nowrap">Emergency Call: 8123996838</span>
            </button>
            <button 
              onClick={handleWhatsAppClick}
              className="bg-emerald-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center mr-2 flex-shrink-0"></i>
              <span className="whitespace-nowrap">WhatsApp Now: 8123996838</span>
            </button>
          </div>
        </div>
      </section>

      {/* Location & Contact */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                Visit Our Kacherypady Clinic
              </h2>
              <div className="space-y-4 mb-8">
                <div className="flex items-start">
                  <i className="ri-map-pin-line w-6 h-6 flex items-center justify-center text-slate-600 mr-3 mt-1"></i>
                  <div>
                    <h3 className="font-semibold text-gray-900">Address</h3>
                    <p className="text-gray-600">SRM Road, Kacherypady, near MG Road, Ernakulam North, Kerala, India</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-phone-line w-6 h-6 flex items-center justify-center text-slate-600 mr-3 mt-1"></i>
                  <div>
                    <h3 className="font-semibold text-gray-900">Phone Number</h3>
                    <p className="text-gray-600">+91 8123996838</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-time-line w-6 h-6 flex items-center justify-center text-slate-600 mr-3 mt-1"></i>
                  <div>
                    <h3 className="font-semibold text-gray-900">Opening Hours</h3>
                    <p className="text-gray-600">Monday - Sunday: 10:00 AM - 8:00 PM</p>
                  </div>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4">
                <button 
                  onClick={handleCallClick}
                  className="bg-slate-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-slate-700 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
                >
                  <i className="ri-phone-line w-5 h-5 flex items-center justify-center mr-2 flex-shrink-0"></i>
                  <span className="whitespace-nowrap">Call Now</span>
                </button>
                <button 
                  onClick={handleWhatsAppClick}
                  className="bg-emerald-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
                >
                  <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center mr-2 flex-shrink-0"></i>
                  <span className="whitespace-nowrap">WhatsApp</span>
                </button>
                <a 
                  href="https://maps.app.goo.gl/dtqxBhCLzHeYeSvv7" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-slate-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-slate-700 transition-colors text-center whitespace-nowrap flex items-center justify-center"
                >
                  <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center mr-2 flex-shrink-0"></i>
                  <span className="whitespace-nowrap">Get Directions</span>
                </a>
              </div>
            </div>
            <div>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.0234567890123!2d76.28489!3d9.9919672!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b080da408d9af75%3A0x7c78c2a63f81681f!2sGalaxy%20Dental%20Care!5e0!3m2!1sen!2sin!4v1737965000000!5m2!1sen!2sin"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="rounded-lg shadow-lg"
                title="Galaxy Dental Care Kacherypady Location"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              What Our Patients Say
            </h2>
            <p className="text-xl text-gray-600">
              Real experiences from our satisfied patients
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="flex items-center mb-4">
                <div className="flex text-amber-400">
                  <i className="ri-star-fill w-5 h-5 flex items-center justify-center"></i>
                  <i className="ri-star-fill w-5 h-5 flex items-center justify-center"></i>
                  <i className="ri-star-fill w-5 h-5 flex items-center justify-center"></i>
                  <i className="ri-star-fill w-5 h-5 flex items-center justify-center"></i>
                  <i className="ri-star-fill w-5 h-5 flex items-center justify-center"></i>
                </div>
              </div>
              <p className="text-gray-600 mb-4">
                "Excellent service at Galaxy Dental Care Kacherypady. The staff is very professional and the treatment was painless. Highly recommended!"
              </p>
              <div className="font-semibold text-gray-900">Priya Nair</div>
              <div className="text-sm text-gray-500">Ernakulam</div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="flex items-center mb-4">
                <div className="flex text-amber-400">
                  <i className="ri-star-fill w-5 h-5 flex items-center justify-center"></i>
                  <i className="ri-star-fill w-5 h-5 flex items-center justify-center"></i>
                  <i className="ri-star-fill w-5 h-5 flex items-center justify-center"></i>
                  <i className="ri-star-fill w-5 h-5 flex items-center justify-center"></i>
                  <i className="ri-star-fill w-5 h-5 flex items-center justify-center"></i>
                </div>
              </div>
              <p className="text-gray-600 mb-4">
                "Got my dental implant done here. The doctors are very skilled and the clinic is well-equipped. Very satisfied with the results."
              </p>
              <div className="font-semibold text-gray-900">Rajesh Kumar</div>
              <div className="text-sm text-gray-500">Kochi</div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="flex items-center mb-4">
                <div className="flex text-amber-400">
                  <i className="ri-star-fill w-5 h-5 flex items-center justify-center"></i>
                  <i className="ri-star-fill w-5 h-5 flex items-center justify-center"></i>
                  <i className="ri-star-fill w-5 h-5 flex items-center justify-center"></i>
                  <i className="ri-star-fill w-5 h-5 flex items-center justify-center"></i>
                  <i className="ri-star-fill w-5 h-5 flex items-center justify-center"></i>
                </div>
              </div>
              <p className="text-gray-600 mb-4">
                "My child loves coming here for dental checkups. The pediatric dentist is amazing with kids. Clean and friendly environment."
              </p>
              <div className="font-semibold text-gray-900">Meera Thomas</div>
              <div className="text-sm text-gray-500">Kakkanad</div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 bg-slate-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Ready for Your Best Smile?
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Book your appointment today at Galaxy Dental Care Kacherypady and experience the difference
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={handleCallClick}
              className="bg-white text-slate-700 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-phone-line w-5 h-5 flex items-center justify-center mr-2 flex-shrink-0"></i>
              <span className="whitespace-nowrap">Call: 8123996838</span>
            </button>
            <button 
              onClick={handleWhatsAppClick}
              className="bg-emerald-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center mr-2 flex-shrink-0"></i>
              <span className="whitespace-nowrap">WhatsApp: 8123996838</span>
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <img 
                  src="https://static.readdy.ai/image/1f14fa9f4e25dd8748ff61378ea7fc70/5f18070c14f635b56d649c93b3a8f8e0.png"
                  alt="Galaxy Dental Care"
                  className="h-12 w-auto"
                />
              </div>
              <p className="text-gray-300 mb-4">
                Your trusted dental partner in Kacherypady, providing exceptional care with modern technology.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
              <div className="space-y-2 text-gray-300">
                <p>📞 Phone: +91 8123996838</p>
                <p>📍 SRM Road, Kacherypady, Ernakulam North</p>
                <p>🕒 Mon-Sun: 10:00 AM - 8:00 PM</p>
              </div>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
              <div className="space-y-2">
                <Link to="/" className="text-gray-300 hover:text-white block">Home</Link>
                <Link to="/about" className="text-gray-300 hover:text-white block">About</Link>
                <Link to="/doctors" className="text-gray-300 hover:text-white block">Doctors</Link>
                <Link to="/contact-us" className="text-gray-300 hover:text-white block">Contact</Link>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-300">
            <p>&copy; 2025 Galaxy Dental Care. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default KacherypladyLandingPage;
